import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'awair-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})

// TODO: Create table component with div instead of table element
// 1. Requires complex javascript logic to make scroll to be visible on tbody only while having dynamic column sizes
// 2. It's difficult to add border and border-radius to tbody only

export class TableComponent implements OnInit {

  @Input() columnHeaders: string[] = [];

  constructor() {
  }

  ngOnInit() {
  }
}
